{
  "markets": {
    "title": "国・通貨",
    "intro": "サイトで販売する国、通貨、国ごとの消費税・関税の扱いです。",
    "read_only": "確認用の表示です。関税は「配送 → 関税」、サイトの言語は「サイトの言語」で変更します。",
    "to_duties": "関税を変更",
    "to_languages": "サイトの言語",
    "error": "国の一覧を読み込めませんでした。",
    "empty": "国がまだ設定されていません。",
    "default": "メイン",
    "on": "販売中",
    "off": "販売停止",
    "rest_of_world": "その他すべての国",
    "countries_more_other": "{{list}} ほか{{count}}か国",
    "currency": "通貨",
    "fixed_rate": "1円 = {{rate}} {{currency}}",
    "fx": {
      "own_table": "店の為替レート",
      "fixed": "固定レート",
      "stripe_adaptive": "カード決済サービスで換算（今後のフェーズ）"
    },
    "tax": "消費税",
    "tax_mode": {
      "domestic": "価格は税込（消費税10%）",
      "export": "輸出 — 日本の消費税なし"
    },
    "duties": "関税",
    "duties_none": "なし（国内販売）",
    "duties_mode": {
      "DDU": "到着時にお客様が支払い（目安 {{rate}}%）",
      "DDP": "注文時にお預かり（{{rate}}%）"
    },
    "free_shipping": "送料無料の金額",
    "free_shipping_none": "未設定"
  },
  "domains": {
    "title": "ドメイン（URL）",
    "intro": "サイト、この管理画面、レジのアドレスです。確認用 — 変更はIT担当が行います。",
    "website": "サイト（お客様用）",
    "admin": "管理画面（この画面）",
    "register": "レジ（店頭）",
    "copy": "コピー",
    "copied": "アドレスをコピーしました。",
    "copy_failed": "コピーできませんでした。アドレスを選んで手動でコピーしてください。",
    "how_to_change": "新しいドメインを使うときはIT担当に依頼してください（ドメイン会社とサーバーで一度設定します）。"
  },
  "lang": {
    "ja": "日本語",
    "en": "English"
  },
  "store": {
    "title": "ショップ情報",
    "intro": "店の情報を一度入力すると、サイトの法定表示ページとすべてのメールのフッターに使われます。",
    "needs_content": "ショップ情報はサイトの内容を編集できるスタッフだけが開けます。",
    "error": "ショップ情報を読み込めませんでした。",
    "facts_title": "店について",
    "facts_intro": "日本語は法律で必要です。英語は海外のお客様に表示されます。",
    "read_only": "ショップ情報を変更できるのはオーナーだけです。見ることはできます。",
    "kobutsu_title": "古物商許可",
    "fields": {
      "shopName": "販売業者（店名・会社名）",
      "representative": "代表者（運営統括責任者）",
      "address": "所在地",
      "phone": "電話番号",
      "phoneHours": "電話受付時間",
      "email": "お客様用メールアドレス",
      "website": "サイトのアドレス",
      "commission": "許可をした公安委員会",
      "licenseNumber": "古物商許可番号",
      "nameKana": "店名（フリガナ）",
      "postalCode": "郵便番号"
    },
    "help": {
      "shopName": "許可証や請求書と同じ名前（会社名または個人名）。",
      "representative": "店の責任者の名前。",
      "address": "店の場所。お客様が連絡できる住所です。",
      "phone": "お客様がかけられる番号。",
      "phoneHours": "電話に出る時間。例: 11:00〜19:00 火曜定休。",
      "email": "お客様からの連絡先。メールにも表示されます。",
      "website": "https:// から始まるサイトのアドレス。",
      "commission": "許可をした公安委員会。例: 東京都公安委員会。",
      "licenseNumber": "許可証の番号（12桁）。サイトに表示が必要です。",
      "nameKana": "店名の読み方をカタカナで（例: カードショップトウキョウ）。",
      "postalCode": "7桁（例: 150-0001）。表記ページでは所在地の前に表示されます。"
    },
    "problems": {
      "email": "メールアドレスの形ではありません。",
      "phone": "数字・空白・+・- だけで入力してください。",
      "website": "https:// から入力してください。",
      "postalCode": "7桁の数字で入力してください（例: 150-0001）。",
      "nameKana": "カタカナで入力してください（例: カードショップ）。",
      "licenseNumber": "数字で入力してください（例: 第301012345678号）。古物商許可証の番号です。"
    },
    "save": "ショップ情報を保存",
    "undo": "変更を取り消す",
    "saved": "保存しました。お客様に表示するには下の「ページを更新」を押してください。",
    "saved_no_footer": "法定表示ページには保存しました。メールのフッターは更新できませんでした — 後でもう一度保存してください。",
    "part_footer": "メールのフッター",
    "saved_parts": "保存しました: {{parts}}。",
    "not_saved": "保存できませんでした: {{parts}} — もう一度保存してください。",
    "not_saved_conflict": "保存できませんでした: {{parts}} — ほかの人が先に変更しました。「最新を読み込む」を押すか、確認してからもう一度保存してください。",
    "conflict": "ほかの人が先にページを変更しました。最新の内容を表示しています — もう一度変更してください。",
    "payments_used": "支払方法を決済設定の内容にしました。",
    "where_used": "使われる場所: 管理画面の上部、レシート、特定商取引法に基づく表記、古物営業法に基づく表示、お問い合わせ、メールのフッター。",
    "tax_title": "税の登録",
    "to_tax": "税の設定を開く",
    "tax_error": "税の設定を読み込めませんでした。",
    "t_number": "登録番号（T番号）",
    "t_number_missing": "未入力",
    "business_name": "登録名",
    "business_type": "事業の形態",
    "business_types": {
      "individual": "個人事業主",
      "corporation": "法人"
    },
    "not_decided": "未定",
    "tax_free": "免税販売",
    "tax_free_yes": "許可あり",
    "tax_free_no": "許可なし",
    "logo_title": "お店のロゴ",
    "logo_help": "管理画面の一番上に全員へ表示されます。メディアライブラリの画像から選びます。",
    "logo_choose": "画像を選ぶ",
    "logo_change": "画像を変える",
    "logo_remove": "ロゴを外す",
    "logo_none": "ロゴはまだありません（店名を表示します）。",
    "logo_picker": "お店のロゴを選ぶ",
    "not_saved_record": "お店の情報は保存されませんでした。先に別の人が変更しています。最新を読み込んでからもう一度お試しください。",
    "record_error": "お店の情報を保存できませんでした。何も変更されていません。",
    "signage": {
      "title": "印刷する掲示物",
      "intro": "上の店舗情報から PDF を作ります。等倍（100%）で印刷し、一度定規でサイズを確認してください。",
      "hyoshiki": "古物商の標識（8×16cm）",
      "identity": "本人確認のお願い（レジ用・A4）",
      "needs_permit": "標識には許可証番号（12桁）・公安委員会・店名の入力が必要です。"
    }
  },
  "tokushoho": {
    "title": "特定商取引法に基づく表記",
    "ring": "{{total}}項目中{{filled}}項目入力済み",
    "filled": "{{total}}項目中{{filled}}項目に日本語が入っています。",
    "all_done": "14項目すべて入力済みです。",
    "law_link": "法律が求めること（消費者庁）",
    "fill": "項目を入力する",
    "returns_missing": "⑪ 返品特約が空欄です。表示しないと、お客様は商品を受け取ってから8日間は契約を解除できます（特商法15条の3）。",
    "returns_guide": "ガイドライン",
    "payments_differ": "⑧ 支払方法が、有効な決済方法「{{text}}」と一致しません。",
    "use_payments": "この内容にする",
    "license_missing": "古物商許可番号が空欄です — サイトへの表示が必要です（古物営業法）。販売はそのまま続けられます。",
    "kobutsu_link": "古物商許可について（警視庁）",
    "still_empty": "未入力:",
    "item_label": "{{no}}. {{label}}",
    "items": {
      "seller": {
        "label": "販売業者",
        "help": "店名または会社名。"
      },
      "representative": {
        "label": "運営統括責任者",
        "help": "代表者の名前。"
      },
      "address": {
        "label": "所在地",
        "help": "事業所の場所。"
      },
      "phone": {
        "label": "電話番号・受付時間",
        "help": "番号と受付時間。"
      },
      "email": {
        "label": "メールアドレス",
        "help": "お客様からの連絡先。"
      },
      "price": {
        "label": "販売価格",
        "help": "価格の表示方法（税込）。"
      },
      "other_fees": {
        "label": "商品代金以外の必要料金",
        "help": "送料、振込手数料、海外の関税など。"
      },
      "payment_methods": {
        "label": "支払方法",
        "help": "有効な決済方法。"
      },
      "payment_timing": {
        "label": "支払時期",
        "help": "例: 注文から3日以内。"
      },
      "delivery_timing": {
        "label": "商品の引渡時期",
        "help": "準備と発送にかかる日数。"
      },
      "returns": {
        "label": "返品・交換（返品特約）",
        "help": "返品できるもの・期限。"
      },
      "quantity": {
        "label": "販売数量の制限",
        "help": "例: お一人様1点まで。"
      },
      "other": {
        "label": "その他",
        "help": "ほかにお客様が知るべきこと。"
      },
      "validity": {
        "label": "申込みの有効期限・キャンセル",
        "help": "未入金の注文を保つ期間。"
      }
    },
    "what_items": "14項目の内容"
  },
  "publish": {
    "title": "サイトに公開",
    "pages": {
      "tokushoho": "特定商取引法に基づく表記",
      "kobutsu": "古物営業法に基づく表示",
      "contact": "お問い合わせ"
    },
    "published_on": "公開日",
    "not_published": "まだ公開されていません",
    "changes_waiting": "未公開の変更あり",
    "save_first": "保存していないショップ情報があります — 先に保存してから公開してください。",
    "missing": "「{{page}}」はまだ公開できません — 次の項目が空欄です:",
    "button": "表記ページを更新",
    "needs_permission": "公開はマネージャーかオーナーが行います。",
    "nothing": "すべてサイトに公開済みです。",
    "done": "サイトに公開しました: {{pages}}。",
    "confirm_title": "サイトの法定表示ページを更新しますか？",
    "confirm_body": "お客様に新しい内容が表示されます: {{pages}}。変更内容を書いてください — ページの履歴に残ります。",
    "confirm": "ページを更新",
    "show_preview": "お客様に見える形で表示",
    "hide_preview": "ページを閉じる",
    "preview_title": "サイトの特定商取引法に基づく表記",
    "history": "以前のバージョン",
    "version": "バージョン {{version}}"
  },
  "policy_fields": {
    "business_name": "販売業者",
    "representative": "運営統括責任者",
    "address": "所在地",
    "phone": "電話番号",
    "phone_hours": "電話受付時間",
    "email": "メールアドレス",
    "url": "URL",
    "price_display": "販売価格",
    "additional_fees": "商品代金以外の必要料金",
    "payment_methods": "支払方法",
    "payment_timing": "支払時期",
    "delivery_timing": "商品の引渡時期",
    "return_policy": "返品特約",
    "quantity_limit": "販売数量の制限",
    "application_validity": "申込みの有効期限",
    "kobutsu_license": "古物商許可",
    "other_notes": "その他",
    "licensee_name": "氏名又は名称",
    "commission_name": "公安委員会の名称",
    "license_number": "許可証番号",
    "notified_url": "届出URL",
    "hours": "受付時間",
    "body": "本文"
  },
  "web_orders": {
    "title": "購入手続き",
    "intro": "サイトでの注文の受け付け方です。",
    "error": "現在の状態を読み込めませんでした。",
    "switch_title": "サイトで注文を受け付ける",
    "state_open": "受付中",
    "state_paused": "一時停止中",
    "explain_open": "お客様はサイトで注文できます。価格の誤り・在庫の問題・臨時休業などのときは一時停止してください。",
    "explain_paused": "サイトに「注文受付を一時停止中」のお知らせが表示されます。商品は見られますが注文はできません。店頭レジには影響しません。",
    "pause": "サイトの注文を一時停止",
    "resume": "注文の受付を再開",
    "confirm_title": "サイトの注文受付を一時停止しますか？",
    "confirm_body": "再開するまで、お客様にはお知らせが表示され注文できません。すでに受けた注文は変わりません。",
    "paused_done": "サイトの注文受付を一時停止しました。",
    "resumed_done": "サイトの注文受付を再開しました。",
    "who_can": "変更できるのはオーナーまたは店長のみです。"
  }
}
